import React,{useContext} from 'react';
import { ListGroup } from 'react-bootstrap';
import NavCollapse from "../NavCollapse";
import NavItem from "../NavItem";
import NavIcon from "../NavIcon";
import { ConfigContext } from '../../../../../contexts/ConfigContext';
const NavGroup = ({ layout, group,activeGroupId=null,onClick=()=>{} }) => {

    const configContext = useContext(ConfigContext)
    const { layoutType } = configContext.state
    const isDarkMenu = layout !== 'horizontal' && ['menu-dark', 'dark'].includes(layoutType)

    let navItems = '';    

    if (group.children) {
        const groups = group.children;
        navItems = Object.keys(groups).map(item => {
            item = groups[item];
            item.color = group.color?group.color:undefined
            
            switch (item.type) {
                case 'collapse':
                    return <NavCollapse key={item.id} collapse={item} type="main" />;
                case 'item':
                    return <NavItem layout={layout} key={item.id} item={item} />;
                default:
                    return false;
            }
        });
    }
    const style = !isDarkMenu && group.color?{color:group.color}:{}
    const menuStyle = isDarkMenu?{backgroundColor:'transparent',color:'inherit'}:{}

    return (
        <React.Fragment>
            <ListGroup.Item as='li' id={group.id} bsPrefix=' ' key={group.id} className={`nav-item pcoded-menu-group ${activeGroupId === group.id ? 'active-group' : ''}`} style={style}>
                <div className={`pcoded-menu-group-title ${isDarkMenu && activeGroupId === group.id ? 'text-white' : ''}`} onClick={onClick}>{group.backIcon && false && (<NavIcon items={group} />)}
                    <label className='text-capitalize'  >{group.title}</label><i className={`fa ${activeGroupId === group.id ? 'fa-angle-up' : 'fa-angle-down'} m-l-5`}/>
                </div>
                <ListGroup.Item as='ul' style={menuStyle}>
                    {navItems}
                </ListGroup.Item>                        
            </ListGroup.Item>                        
        </React.Fragment>
    );
};

export default NavGroup;
